import React from 'react';
import { arrayOf, shape, string } from 'prop-types';
import styled from 'styled-components';
import categoryProps from 'TMPropTypes/categoryProps';
import { breakpoints } from 'TMConstants';
import CategoryPill from 'TMComponents/CategoryPill';
import { H4 } from 'TMComponents/Typography';

const Wrapper = styled.div`
    margin-bottom: 32px;
`;

const FilterText = styled(H4)`
    margin-bottom: 0px;
    margin-top: 0;
`;

/**
 * Pills wrap onto as many rows as they need at every width. The filter used to
 * be a single `white-space: nowrap` row with `overflow-x: scroll` below the
 * tablet breakpoint, which hid most of the 17 categories behind a horizontal
 * scroll people don't discover.
 */
const CategoryList = styled.div`
    display: flex;
    flex-wrap: wrap;
    padding-bottom: 8px;
    border-bottom: 2px solid
        ${({ theme }) => theme.colorSystem.UIElements[4]};

    @media (min-width: ${breakpoints.mobileTablet}px) {
        border-bottom: none;
    }
`;

/**
 * Each pill is a link to a build-time category listing page, so every
 * category is crawlable and a filtered view is a shareable URL.
 */
const CategoryFilter = ({ categories, activeSlug }) => (
    <Wrapper>
        <FilterText>Categories:</FilterText>
        <CategoryList>
            <CategoryPill
                allowToggle
                name="All articles"
                to="/blog/"
                isActive={!activeSlug}
            />
            {categories.map(({ name, slug, basePath }) => (
                <CategoryPill
                    key={slug}
                    allowToggle
                    name={name}
                    to={basePath}
                    isActive={slug === activeSlug}
                />
            ))}
        </CategoryList>
    </Wrapper>
);

CategoryFilter.propTypes = {
    categories: arrayOf(shape(categoryProps)).isRequired,
    activeSlug: string
};

CategoryFilter.defaultProps = {
    activeSlug: undefined
};

export default CategoryFilter;
